import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import ProtectedRoute from "components/util-components/ProtectedRoute";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import Orders from "./orders";
import Finance from "./finance";
import Products from "./products";
import Reports from "./reports";
import Customers from "./customers";
import Companies from "./customers/companies";
import Notifications from "./notifications";
import Groups from "./groups";
import Discounts from "./discounts";
import Profile from "./profile";
import { WebshopUsersProvider } from "../../data/hooks/firestore/useWebshopUsers";
import Acquisition from "./acquisition";
import ChatViews from "./chat";
import Countries from "./countries";
import EdiLog from "./edilog";

export const AppViews = () => {
  return (
    <WebshopUsersProvider>
      <Suspense fallback={<Loading cover="content" />}>
        <Routes>
          <Route path={`/reports/*`} element={<Reports />} />
          <Route path={`/products/*`} element={<Products />} />
          <Route path={`/orders/*`} element={<Orders />} />
          <Route path={`/finance/*`} element={<Finance />} />
          <Route path={`/acquisition/*`} element={<Acquisition />} />
          <Route path={`/customers/*`} element={<Customers />} />
          <Route path={`/companies/*`} element={<Companies />} />
          <Route
            path={`/notifications/*`}
            element={
              <ProtectedRoute routeKey={"shop-notifications"}>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route
            path={`/groups/*`}
            element={
              <ProtectedRoute routeKey={"shop-groups"}>
                <Groups />
              </ProtectedRoute>
            }
          />
          <Route
            path={`/discounts/*`}
            element={
              <ProtectedRoute routeKey={"shop-discount"}>
                <Discounts />
              </ProtectedRoute>
            }
          />
          <Route path={`/chat/*`} element={<ChatViews />} />
          <Route
            path={`/countries/*`}
            element={
              <ProtectedRoute routeKey={"shop-countries"}>
                <Countries />
              </ProtectedRoute>
            }
          />
          <Route
            path={`/edilog`}
            element={
              <ProtectedRoute routeKey={"shop-edi-log"}>
                <EdiLog />
              </ProtectedRoute>
            }
          />
          <Route path={``} element={<Navigate to={`${APP_PREFIX_PATH}/products`} replace />} />
          <Route path={`/profile/*`} element={<Profile />} />
        </Routes>
      </Suspense>
    </WebshopUsersProvider>
  );
};

export default React.memo(AppViews);
